import { render } from "./SingleWalletTesting.vue?vue&type=template&id=f9358f9a&scoped=true"
import script from "./SingleWalletTesting.vue?vue&type=script&lang=js"
export * from "./SingleWalletTesting.vue?vue&type=script&lang=js"

import "./SingleWalletTesting.vue?vue&type=style&index=0&id=f9358f9a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src710843524/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9358f9a"]])

export default __exports__